export const urlUtils = {
  removeProtocol(url: string) {
    return url.replace(/(^\w+:|^)\/\//, '');
  },
  addProtocol(url: string, isSecure = true) {
    if (/(http(s?)):\/\//i.test(url)) {
      return url;
    }
    return `http${isSecure ? 's' : ''}://${url}`;
  },
  removeDomain(url: string) {
    // adapted from https://stackoverflow.com/questions/6945429/javascript-how-to-remove-domain-from-location-href
    return url.replace(/^.*\/\/[^/]+/, '');
  },
  removeTrailingSlash(url: string) {
    if (url.length > 1 && url.substr(-1) === '/') {
      return url.substr(0, url.length - 1);
    }
    return url;
  },
};
